export default function InputField() {
  const inputFields = document.querySelectorAll('.input-field input');
  const inputFieldHasValueClass = 'input-field--has-value';

  function handleInputField (inputField) {
    let inputFieldContainer = inputField.closest('.input-field');

    inputField.addEventListener('keyup', function () {
      inputField.value.length > 0 ?
        inputFieldContainer.classList.add(inputFieldHasValueClass) : inputFieldContainer.classList.remove(inputFieldHasValueClass);
    });
  };

  inputFields.forEach(inputField => handleInputField(inputField));
};
